import {FinalQuestionRenderer} from './FinalQuestionRenderer.js'
import {MultiselectQuestionRenderer} from './MultiselectQuestionRenderer.js'
import {ScaleQuestionRenderer} from './ScaleQuestionRenderer.js'

export const questionRenderers = {
  SCALE: new ScaleQuestionRenderer(),
  MULTISELECT: new MultiselectQuestionRenderer(),
  FINAL: new FinalQuestionRenderer()
}
